export async function zefixCompanySearch(name: string) {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/zefix/search/${encodeURIComponent(name)}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )

  return response.json()
}

export async function zefixCompanyDetails(uid: string, clientId?: string) {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/zefix/company/${uid}/${clientId ? `${clientId}` : ''}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )

  return response.json()
}

export async function zefixCompanyExtract(clientId: string) {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/zefix/extract?clientId=${clientId}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )

  return response.json()
}

export async function zefixCompanyExtractByClientId(clientId: string) {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/zefix/company/${clientId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })

  return response.json()
}

export async function zefixAuditLogs(clientId: string) {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/zefix/audit-logs/${clientId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })

  return response.json()
}
